import React from 'react';
import { Table } from 'react-bootstrap';

function AdminVideoList(props) {
    return (
        <div>
            <Table striped bordered className='mt-3'>
                <thead>
                    <tr>
                        <td>Doc ID</td>
                        <td>File Name</td>
                        <td>URL</td>
                    </tr>
                </thead>
                <tbody>
                {
                    props.videos.map((v, i) => {
                        return (
                            <tr key={i}><td>{v.id}</td><td>{v.filename}</td><td style={{width: '500px'}}>{v.url}</td></tr>
                        );
                    })
                }
                </tbody>
            </Table>
        </div>
    );
}

export default AdminVideoList;
